import axios from "axios";

async function getPartFiles({
        ref, 
        currentUser, 
        partFilesDetail, 
        setPartFilesDetail
    }) {
    await axios({
        method: 'post', 
        url: process.env.REACT_APP_SERVER_NAME,
        params: {ass: 'gf'},
        data: {
            user_email: currentUser.email,
            user_teamUid: currentUser.teamUid,
            user_role: currentUser.role,
            action: "readPartFile",
            part_ref: ref
        },
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + currentUser.token
        }
    }).then((resp) => {
        if (resp.status === 200 && resp.data) {
            setPartFilesDetail({
                ...partFilesDetail, 
                ref: ref,
                message: resp.data.partFiles.message,
                existsPartsFiles: resp.data.partFiles.existsPartsFiles
            });
        }
    })
}

export default getPartFiles;